import { useParams, useSearchParams } from "react-router-dom"
import { useGetMoneyFlow } from "../api/case/document.ts"
import { useCallback, useMemo } from "react"

export const useCurrentStep = () => {
    const { documentId } = useParams()
    const [searchParams, setSearchParams] = useSearchParams()
    const { data: moneyFlow } = useGetMoneyFlow(documentId)

    const currentStep = useMemo(
        () => +(searchParams.get('step') ?? ((moneyFlow?.sankeyData.length || 1) - 1)),
        [moneyFlow?.sankeyData.length, searchParams]
    )

    const isLastStep = useMemo(
        () => +currentStep === (moneyFlow?.sankeyData.length || 1) - 1,
        [currentStep, moneyFlow?.sankeyData.length]
    )

    const isInitialStep = useMemo(() => +currentStep === 0, [currentStep])

    const setStep = useCallback((step: number, callback?: (searchParams: URLSearchParams) => void) => {
        const newSearchParams = new URLSearchParams(searchParams)
        if (step + 1 === moneyFlow?.sankeyData.length) {
            newSearchParams.delete('step')
        } else {
            newSearchParams.set('step', String(step))
        }
        if (callback) {
            callback(newSearchParams)
        } else {
            setSearchParams(newSearchParams)
        }
    }, [moneyFlow?.sankeyData.length, searchParams, setSearchParams])

    const changeStep = useCallback((operation: 'increment' | 'decrement') => {
        const sign = operation === 'increment' ? 1 : -1
        const newStep = +(currentStep ?? 0) + 1 * sign
        setStep(newStep)
    }, [currentStep, setStep])

    return {
        currentStep,
        changeStep,
        setStep,
        isLastStep,
        isInitialStep
    }
}
